import '../styles/base.scss'
import '../styles/loading.scss'
import '../styles/landing.scss'
import '../styles/links.scss'
import '../styles/skills.scss'
import '../styles/feedback.scss'
import '../styles/swiper.scss'
import '../styles/projects.scss'
import '../styles/faq.scss'
import '../styles/contact.scss'
import '../styles/about.scss'
import '../styles/interests.scss'